<a class="nav-link dropdown-toggle white btn-hover-pepsico fnt-13" href="#!" role="button" id="dropdownMenuLink22"
  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  <img [src]="holidayDataService.holidaysData()[HolidayTypes.Cart]" width="25">
  @if(cartDataService.hasCartArticles()){
  <span class="icon-button__badge2">
    {{ cartDataService.cartCounter() }}
  </span>
  }
</a>
<div class="hover-label">Carrito</div>
<div class="dropdown-menu notificationBox" aria-labelledby="dropdownMenuLink22">
  <div class="notificationTriangle-carrito-desktop is-active"></div>
  @if(cartDataService.hasCartArticles()) {
  <div class="notificationHeader">
    <div class="notificationHeader--title">
      Artículos en el carrito
    </div>
    <div class="notificationHeader--unread">
      <div>
        {{ cartDataService.cartCounter() }}
        {{ cartDataService.cartCounter() | i18nPlural: articleMap()}}
      </div>
    </div>
  </div>
  <div>
    <div class="notificationList">
      <div>
        @for (item of cartDataService.cartData()?.items; track item.detailCatalogId) {
        <div class="notification">
          <div class="container">
            <div class="row img-carrito">
              <div class="col-sm">
                <img [src]="item.pathImage" width="100px">
              </div>
              <div class="col-sm">
                <p class="fnt-12">{{ item.description }}</p>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="container">
      <div class="row jf-center">
        <button type="button" routerLink="cart" class="btn btn-red carrito-btn-2 w-290">
          Canjear
        </button>
      </div>
    </div>
  </div>
  } @else {
  <div class="notificationHeader">
    <div class="notificationHeader--title">
      Actualmente no hay artículos en el carrito
    </div>
  </div>
  }
</div>